import { IProductBase } from '../../models/products';
import IListResponse from '../../utils/list-response';
import jhsfBookingsApi from '../apis/jhsfBookingsApi';

interface IListProductProps {
  isActive?: boolean;
  name?: string;
  sort?: 'name' | 'createdAt';
  order?: 'ASC' | 'DESC';
  limit?: number;
  page?: number;
}

export type IProductListItem = IProductBase;

export type IProductList = IListResponse<IProductListItem>;

export const listProductsService = async (
  filters?: IListProductProps,
): Promise<IProductList> => {
  const params =
    filters && Object.keys(filters).length !== 0
      ? {
          isActive: filters.isActive,
          name: filters.name || undefined,
          sort: filters.sort,
          order: filters.order,
          limit: filters.limit,
          page: filters.page,
        }
      : undefined;

  const { data } = await jhsfBookingsApi.get<IProductList>('/products', {
    params,
  });

  return data;
};
